/* @flow */
import React from 'react';
import { Container } from 'flux/utils';

import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import Messages from 'collections/Messages';
import Group from 'entities/Group';
import GroupScheduledMessageList from 'groups/components/GroupScheduledMessageList.jsx';
import MessageStore from 'groups/stores/MessageStore';
import { getGroupKey, EVERYONE } from 'utils/roleHelpers';

class ScheduledAnnouncementsDialog extends React.Component<
  {
    messagesScheduled: Messages,
    group: Group,
    onRequestHide: Function,
    target: *,
  },
  *
> {
  static getStores() {
    return [MessageStore];
  }

  static calculateState(prevState, props) {
    const { group, target } = props;
    const role = target ? target.role : EVERYONE;
    if (group) {
      return {
        messagesScheduled: MessageStore.getMessagesScheduled(getGroupKey(group.id, role)),
      };
    }

    return {};
  }

  constructor(props) {
    super(props);
    this.state = {
      messagesScheduled: props.messagesScheduled,
    };
  }

  componentDidUpdate() {
    if (!this.state.messagesScheduled || this.state.messagesScheduled.isEmpty()) {
      this.props.onRequestHide();
    }
  }

  render() {
    return (
      <Dialog
        eventScreenName="ScheduledAnnouncementsDialog"
        {...this.props}
        className="ScheduledAnnouncementsDialog"
        title="Scheduled Announcements"
        size="medium">
        <BoxBody>
          <GroupScheduledMessageList
            group={this.props.group}
            messages={this.state.messagesScheduled}
            target={this.props.target}
          />
        </BoxBody>
      </Dialog>
    );
  }
}

export default Container.create(ScheduledAnnouncementsDialog, {
  withProps: true,
  pure: false,
});
